<template>
  <div class="p-config-management-user">
    <div class="p-config-management-user__header l-block__header">
      <div class="p-config-management-user__title">
        <TitleSub level="h4">ユーザーの追加と削除</TitleSub>
        <p class="l-mt-1">
          ユーザーの追加・削除・権限の変更ができます。<br />
          特定のサイトのみ利用するユーザーを追加したい場合は、サイト限定ユーザーの権限を付与した後、<br />
          下の【アクセス権を追加】で対象のユーザーにサイトのアクセス権を付与してください。<br />
          ※アカウント管理ユーザーの権限を付与した場合、全サイトにアクセスできるようになります。
        </p>
      </div>
      <Button
        variant="main"
        fsize="f16"
        icon="plus"
        class="l-w-220 l-pr-4"
        :disabled="hasOrganizations"
        @click="openModalAdd"
      >
        ユーザーを追加する
      </Button>
    </div>
    <div class="p-config-management-user__content">
      <ListUser
        :items="users"
        :isLoading="isLoading"
        @delete="openModalDelete"
        @edit="openModalEdit"
        @invite="openModalInvite"
      />
    </div>
    <template v-if="!hasOrganizations">
      <ModalAddUser
        v-if="modal.add.isActive"
        @add="addUser"
        @close="closeModalAdd"
      />
      <ModalDeleteUser
        v-if="modal.delete.isActive"
        :item="modal.delete.item"
        @delete="deleteUser"
        @close="closeModalDelete"
      />
      <ModalEditUser
        v-if="modal.edit.isActive"
        :item="modal.edit.item"
        @edit="editUser"
        @close="closeModalEdit"
      />
      <ModalInviteUser v-if="modal.invite.isActive" @close="closeModalInvite" />
    </template>
  </div>
</template>

<script>
import Button from '@/components/Button';
import ListUser from '@/components/config/ListUser';
import ModalAddUser from '@/components/config/ModalAddUser';
import ModalDeleteUser from '@/components/config/ModalDeleteUser';
import ModalEditUser from '@/components/config/ModalEditUser';
import ModalInviteUser from '@/components/config/ModalInviteUser';
import TitleSub from '@/components/TitleSub';

export default {
  components: {
    Button,
    ListUser,
    ModalAddUser,
    ModalDeleteUser,
    ModalEditUser,
    ModalInviteUser,
    TitleSub
  },
  data() {
    return {
      modal: {
        add: {
          isActive: false
        },
        delete: {
          item: null,
          isActive: false
        },
        edit: {
          item: null,
          isActive: false
        },
        invite: {
          isActive: false
        }
      },
      isLoading: true
    };
  },
  computed: {
    organization() {
      return this.$store.getters['view/organization'];
    },
    users() {
      return this.$store.state.organizations.users;
    },
    hasOrganizations() {
      return this.$store.getters['user/hasOrganizations'];
    }
  },
  created() {
    this.getUsers();
  },
  methods: {
    getUsers() {
      this.isLoading = true;
      this.$store.dispatch('organizations/getUsers').finally(() => {
        this.isLoading = false;
      });
    },
    addUser() {
      this.getUsers();
    },
    deleteUser(item) {
      this.closeModalDelete();

      const users = this.users.slice();
      const index = users.findIndex(user => user.userId === item.userId);
      users.splice(index, 1);
      this.$store.dispatch('organizations/setUsers', users);
    },
    editUser(item) {
      this.closeModalEdit();

      const users = this.users.slice();
      const index = users.findIndex(user => user.userId === item.userId);
      users.splice(index, 1, item);
      this.$store.dispatch('organizations/setUsers', users);
    },
    openModalAdd() {
      this.modal.add.isActive = true;
    },
    closeModalAdd() {
      this.modal.add.isActive = false;
    },
    openModalDelete(item) {
      this.modal.delete.item = item;
      this.modal.delete.isActive = true;
    },
    closeModalDelete() {
      this.modal.delete.item = null;
      this.modal.delete.isActive = false;
    },
    openModalEdit(item) {
      this.modal.edit.item = item;
      this.modal.edit.isActive = true;
    },
    closeModalEdit() {
      this.modal.edit.item = null;
      this.modal.edit.isActive = false;
    },
    openModalInvite() {
      this.modal.invite.isActive = true;
    },
    closeModalInvite() {
      this.modal.invite.isActive = false;
    }
  }
};
</script>
